<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_viii"></a>Acknowledgements</h2>
<p class="noindent">My thanks go to the staff at the Palace Green Library, Durham University for allowing me access to the Grey Papers; to the British Library; to the National Archives, Kew; and to the Surrey History Centre.</p>
<p class="indent">On a more personal level, this book could never have been completed without the love and support of my long-suffering wife Jen, who did not bat an eyelid when I told her I would need to go to the UK for two-and-a-half weeks to rustle through the papers of a general she had never heard of, for a book about a campaign that seemed impossibly obscure. By such love and support is history made.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?10e89f81